module.exports = __webpack_public_path__ + "static/media/omni-channel.41c3df15.png";